import { motion } from "framer-motion";

const steps = [
  { n: "01", t: "Kontakt & Anfrage", d: "Sie schildern uns Ihr Anliegen — telefonisch oder über das Formular. Unverbindlich und kostenlos." },
  { n: "02", t: "Besichtigung & Angebot", d: "Wir verschaffen uns ein Bild vor Ort und erstellen Ihnen ein transparentes, faires Angebot." },
  { n: "03", t: "Termin & Ausführung", d: "Wir vereinbaren einen passenden Termin und erledigen die Arbeit gründlich und pünktlich." },
  { n: "04", t: "Ergebnis & Pflege", d: "Auf Wunsch übernehmen wir die regelmäßige Unterhaltsreinigung — für dauerhaften Durchblick." },
];

export default function Process() {
  return (
    <section id="ablauf" className="relative bg-[#0A111F] py-28 md:py-36 border-y border-white/10">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-cyan-glass mb-5">
          So arbeiten wir
        </p>
        <h2 className="font-heading text-4xl md:text-6xl font-medium tracking-tight text-white mb-16 max-w-2xl">
          In vier Schritten zur perfekten Sauberkeit
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`process-step-${s.n}`}
              className="bg-[#0A111F] p-8 md:p-10"
            >
              <span className="font-mono text-2xl text-cyan-glass">{s.n}</span>
              <h3 className="font-heading text-xl font-medium text-white mt-8 mb-3">{s.t}</h3>
              <p className="text-sm font-light leading-relaxed text-white/55">{s.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
